module.exports = __webpack_public_path__ + "img/19.bf8f0aa2.jpg";